import * as React from "react";
import { useTranslation } from "react-i18next";
import { SelectedRowsProvider, PaginationProvider } from "common/contexts";
import { Alert } from "components/bootstrap";
import { Spinner } from "components/common";
import IlluminatePacksList from "security-app/components/common/ThreatCoverageWidget/ImproveCoverageModal/IlluminatePacksList";
import useThreatRelatedIlluminatePacks from "./useThreatRelatedIlluminatePacks";
const IlluminatePacksEnable = () => {
  const { t } = useTranslation("enterprise_security_app");
  const { allPacks, notEnabledPacks, isInitialLoading } = useThreatRelatedIlluminatePacks();
  if (isInitialLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(SelectedRowsProvider, null, /* @__PURE__ */ React.createElement(PaginationProvider, { initFilters: { tags: "attack" } }, allPacks.length > 0 && notEnabledPacks.length === 0 ? /* @__PURE__ */ React.createElement(Alert, { bsStyle: "success" }, t("illuminate_packs_enable.all_activated")) : /* @__PURE__ */ React.createElement(IlluminatePacksList, null)));
};
export default IlluminatePacksEnable;
